import { Typography, App } from 'antd';
import { CopyOutlined } from '@ant-design/icons';

/** 资源直链列：展示并可一键复制，供第三方下载使用。 */
export function ResourceURL({ url }: { url?: string }) {
  const { message } = App.useApp();
  if (!url) {
    return <Typography.Text type="secondary">-</Typography.Text>;
  }
  return (
    <Typography.Paragraph
      className="resource-url"
      copyable={{
        text: url,
        tooltips: ['复制链接', '已复制'],
        icon: [<CopyOutlined key="c" />, <CopyOutlined key="d" />],
        onCopy: () => message.success('资源地址已复制'),
      }}
      ellipsis={{ rows: 2, tooltip: url }}
      style={{ marginBottom: 0, maxWidth: 280, fontSize: 12, wordBreak: 'break-all' }}
    >
      {url}
    </Typography.Paragraph>
  );
}
